import Model from './Model'

export interface ReleaseData {
  id: number
  version: string
  logs: string | any
  description: string
  released_at: string
  created_at: string
  updated_at: string
  feedbacks: any[]
  released_by: string
}

export default class ReleaseModel extends Model {
  public id: number|undefined
  public data: ReleaseData|undefined

  resource () : string {
    return 'releases'
  }
}
